import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 19l18 0","key":"svg-0"}],["path",{"d":"M5 7a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1l0 -8","key":"svg-1"}]]

const IconDeviceLaptop = createReactComponent('outline', 'device-laptop', 'DeviceLaptop', __iconNode);

export default IconDeviceLaptop;